import getCoreNonPrimaryFulfilmentStrings from "../../../getCoreNonPrimaryFulfilmentStrings";

const getCoreNonPrimaryA11yFulfilmentString = ({ source }) => {
  const { source_info_label, sourceDescription } =
    getCoreNonPrimaryFulfilmentStrings({ source });

  return `${source_info_label} ${sourceDescription}`;
};

export default getCoreNonPrimaryA11yFulfilmentString;
